import React from 'react';
import styled from 'styled-components';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import { FaSpotify, FaApple } from 'react-icons/fa';
import { SiYoutubemusic } from 'react-icons/si';

import { Section, Container } from '@components/global';
import ExternalLink from '@common/ExternalLink';

const RELEASES = [
  // ——— 2024 ———
  {
    name: 'Ser',
    image: 'ser.png',
    date: '2024-12-09',
    type: 'Single',
    sources: {
      spotify:
        'https://open.spotify.com/intl-es/album/2qGHLbULlSzD3E0Lb2zIkP?si=rA1ZAeZaS--ycIqgTO0Dnw',
      apple: 'https://music.apple.com/us/album/ser-single/1779364519',
      youtubeMusic:
        'https://music.youtube.com/playlist?list=OLAK5uy_kSGzuv0udAgmLKe2QhGm5O8EQttpsZyxA',
      youtube:
        'https://www.youtube.com/watch?v=cTwVvcw9-xE&list=PLVT_SuRbVGo29ZEoO8UI6fl8ohCmLQs0J&index=1',
    },
  },
  {
    name: 'Todo Encriptado',
    image: 'todoencriptado.png',
    date: '2024-10-25',
    type: 'Single',
    sources: {
      spotify:
        'https://open.spotify.com/intl-es/album/6H21ZXSlUQKgRBUUlaJEB2?si=Huzto-RqQBmdynmfN5SVZg',
      apple:
        'https://music.apple.com/us/album/todo-encriptado-single/1771034514',
      youtubeMusic: 'https://music.youtube.com/watch?v=cbxNRjj-iTg',
      youtube: 'https://www.youtube.com/watch?v=cbxNRjj-iTg',
    },
  },
  {
    name: 'Chachachá',
    image: 'chachacha.jpg',
    date: '2024-07-26',
    type: 'Single',
    sources: {
      spotify: 'https://open.spotify.com/intl-es/track/6nrF9ULYpyAHdh8A8v9lHp',
      apple: 'https://music.apple.com/au/song/chachach%C3%A1/1756624785',
      youtubeMusic:
        'https://music.youtube.com/playlist?list=OLAK5uy_nYtWJixAhYPwDsi35rPaVkmi9E621WFXs',
    },
  },
  {
    name: 'Caballo Viejo',
    image: 'caballoviejo.jpg',
    date: '2024-06-14',
    type: 'Single',
    sources: {
      spotify:
        'https://open.spotify.com/intl-es/album/5haJlOYANexr9AvxzKNgGQ?si=Vzvl274kQyyjAkaKAUCJ-g',
      apple: 'https://music.apple.com/us/album/caballo-viejo-single/1756902519',
      youtubeMusic:
        'https://music.youtube.com/playlist?list=OLAK5uy_njsy1yVSBOEkZurt6ziUZmYBQiSdgRMTY',
      youtube: 'https://www.youtube.com/watch?v=VuF0taWRzn4',
    },
  },
  {
    name: 'Departamento',
    image: 'departamento.jpg',
    date: '2024-04-12',
    type: 'Single',
    sources: {
      spotify:
        'https://open.spotify.com/intl-es/album/1bO485W8CcsFbGSut9uNnO?si=WNWRzfPxRtqbKSPEswTkHg',
      apple: 'https://music.apple.com/mx/album/departamento-single/1735670130',
      youtubeMusic:
        'https://music.youtube.com/playlist?list=OLAK5uy_kZAlEOsWh5jBm_kp1LBhtUMkqOA2PgRMs',
    },
  },
  {
    name: 'Ya no te hago falta',
    image: 'yanotehagofalta.jpg',
    date: '2024-03-21',
    type: 'Single',
    sources: {
      spotify: 'https://open.spotify.com/track/7AdIUbzv4xKYnVmGTuAaka',
      apple:
        'https://music.apple.com/us/album/ya-no-te-hago-falta-single/1734139362',
      youtubeMusic:
        'https://music.youtube.com/playlist?list=OLAK5uy_lIAUvDyCYKlNF15jdSiEt6CQoVIZ0yvwA',
      youtube: 'https://www.youtube.com/watch?v=GLsw4ayAqTA',
    },
  },

  // ——— 2022 ———
  {
    name: 'El Efecto Fantasmal',
    image: 'efectofantasmal.jpg',
    date: '2022-02-25',
    type: 'Album',
    sources: {
      spotify: 'https://open.spotify.com/album/0yOG6jZvIHxGn4tCLU62FX',
      apple:
        'https://music.apple.com/us/album/el-efecto-fantasmal-single/1608946647',
      youtubeMusic:
        'https://music.youtube.com/playlist?list=OLAK5uy_nGduJdf3-Yt9NpVF3vsWAGEMTfyPOWeW8',
    },
  },

  // ——— 2021 ———
  {
    name: 'La Magia',
    image: 'lamagia.png',
    date: '2021-08-27',
    type: 'Single',
    sources: {
      spotify: 'https://open.spotify.com/album/1BkuUmWtnX6PCrhL32JDL4',
      apple: 'https://music.apple.com/us/album/la-magia-single/1580255046',
      youtubeMusic:
        'https://music.youtube.com/playlist?list=OLAK5uy_lQJFrl-F1l0EVHEpm1jHsoDwUQD5s7ECA',
      youtube: 'https://www.youtube.com/watch?v=fGPN-UI6MMo',
    },
  },

  // ——— 2020 ———
  {
    name: 'Encuentro',
    image: 'encuentro.jpg',
    date: '2020-11-10',
    type: 'Single',
    sources: {
      spotify: 'https://open.spotify.com/album/51YzGcwLHAd8yjDyJb0M5W',
      apple: 'https://music.apple.com/us/album/encuentro-single/1536727298',
      youtubeMusic:
        'https://music.youtube.com/playlist?list=OLAK5uy_kkxqvFnl4Bt-36MY5abvzTSaSu6leyHMQ',
      youtube: 'https://www.youtube.com/watch?v=o8Dbgg-MJNI',
    },
  },

  // ——— 2016 ———
  {
    name: 'Tus colores',
    image: 'tuscolores.jpg',
    date: '2019-03-03',
    type: 'Album',
    sources: {
      spotify: 'https://open.spotify.com/album/1MEQihmkPO5j6gzooSni5b',
      apple: 'https://music.apple.com/us/album/tus-colores/1481867655',
      youtubeMusic:
        'https://music.youtube.com/playlist?list=OLAK5uy_lW0AK0SU_rFi19CMCOuaptZHRo3lnPMks',
    },
  },
];

const Team = () => (
  <StaticQuery
    query={graphql`
      query {
        allFile(filter: { sourceInstanceName: { eq: "releases" } }) {
          edges {
            node {
              relativePath
              childImageSharp {
                fluid(maxWidth: 400, maxHeight: 400) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
        art_team: file(
          sourceInstanceName: { eq: "art" }
          name: { eq: "team_work" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1600) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }
      }
    `}
    render={data => (
      <Section id="releases" accent="secondary">
        <Container style={{ position: 'relative' }}>
          <h1>Releases</h1>
          <ReleaseGrid>
            {RELEASES.map(({ name, image, date, type, sources }) => {
              const img = data.allFile.edges.find(
                ({ node }) => node.relativePath === image
              ).node;

              return (
                <div key={name}>
                  <Img fluid={img.childImageSharp.fluid} alt={name} />
                  <Title>{name}</Title>
                  <Subtitle>
                    {new Date(date).getFullYear()} · {type}
                  </Subtitle>
                  <MusicUrls>
                    <ExternalLink key={sources.spotify} href={sources.spotify}>
                      <FaSpotify size={18} />
                    </ExternalLink>
                    <ExternalLink key={sources.apple} href={sources.apple}>
                      <FaApple size={18} />
                    </ExternalLink>
                    <ExternalLink
                      key={sources.youtubeMusic}
                      href={sources.youtubeMusic}
                    >
                      <SiYoutubemusic size={18} />
                    </ExternalLink>
                  </MusicUrls>
                </div>
              );
            })}
          </ReleaseGrid>
        </Container>
      </Section>
    )}
  />
);

const MusicUrls = styled.div`
  display: flex;
  justify-content: space-around;
  color: #000;
  padding: 12px;
  gap: 20px;

  & a {
    text-decoration: none;
    color: ${props => props.theme.color.black.light};
    transition: transform 0.2s ease, color 0.2s ease;

    &:hover {
      transform: scale(1.1);
      color: ${props => props.theme.color.primary};
    }
  }
`;

const ReleaseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 200px);
  grid-template-rows: min-content;
  grid-gap: 50px;
  justify-content: space-between;
  width: 90%;
  margin-top: 72px;
  text-align: center;

  @media (max-width: ${props => props.theme.screen.lg}) {
    justify-content: start;
  }

  @media (max-width: ${props => props.theme.screen.md}) {
    width: 100%;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  }

  @media (max-width: ${props => props.theme.screen.xs}) {
    grid-gap: 24px;
  }
`;

const Title = styled.p`
  margin-top: 16px;
  color: ${props => props.theme.color.black.regular};
`;

const Subtitle = styled.p`
  ${props => props.theme.font_size.small};
  color: ${props => props.theme.color.black.light};
`;

export default Team;
